export const CATALOG_VIEWS = ["prices", "lists"] as const;

export const CATALOG_INNER_PARAMS = ["q", "list", "page", "perPage"];
